import _ from "lodash";

export const clearCase = (str) => {
  if (!str || typeof str !== 'string') return '';

  return str.toLowerCase()
    .replace(/[\],`~!@#§$%^&*()_|+\-=?;:<>./[\\}/{'\\ ", ]/gi, '');
}

export const camelToSnackStr = (str) => {
  if (!str || typeof str !== 'string') return null;

  return str[0].toLowerCase() + str.slice(1, str.length).replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);  
}

export const camelToSnakeObj = (data) => {
  if (!data || typeof data !== 'object' || _.isArray(data)) return null;
  
  Object.keys(data).forEach(key => {
    const strgSnakeCase = camelToSnackStr(key);

    if (
      !key ||
      key.indexOf('_') > -1 ||
      !strgSnakeCase ||
      strgSnakeCase === key
    ) return;

    data[strgSnakeCase] = data[key];
    delete(data[key]);
  });

  return data;
}

export const camelToSnack = (data) => {
    if (typeof data === 'object') return camelToSnakeObj(data);

    return camelToSnackStr(data);
}

// snake to camel
const snakeToCamelStr = (str) => {
  if (!str || typeof str !== 'string') return null;

  return str.replace(/([-_][a-z])/ig, ($1) => $1.toUpperCase()
    .replace('-', '')
    .replace('_', ''));
}

// convert object keys to camel case
export const snakeToCamelObj = (data) => {
  if (!data || typeof data !== 'object' || _.isArray(data)) return null;

  Object.keys(data).forEach(key => {
    const camelCaseStr = snakeToCamelStr(key);

    if (
      !key ||
      key.indexOf('_') === -1 ||
      !camelCaseStr ||
      camelCaseStr === key
    ) return;

    data[camelCaseStr] = data[key];
    delete(data[key]);
  });

  return data;
}